import { keyframes } from '@emotion/react'

export const ROLL_SLIDER = keyframes`
  0% { min-width: 0px; opacity: 0; transform: translateY(-50px); font-size: 0px; }
  2% { opacity: 1; transform: translateY(0px); font-size: 24px; }
  20% { opacity: 1; transform: translateY(0px); font-size: 24px; }
  22% { opacity: 0; transform: translateY(50px); font-size: 0px; }
  100% { opacity: 0; }
`
